import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BrainIcon, ArrowRightIcon, ClockIcon } from 'lucide-react';
import QuizExitPopup from './QuizExitPopup';
const QuizLanding = () => {
  const [showExitPopup, setShowExitPopup] = useState(false);
  useEffect(() => {
    // Exit intent detection
    const handleMouseLeave = e => {
      if (e.clientY <= 0 && !showExitPopup) {
        setShowExitPopup(true);
      }
    };
    // Add exit intent detection
    document.addEventListener('mouseleave', handleMouseLeave);
    return () => {
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [showExitPopup]);
  const handleContinueQuiz = () => {
    setShowExitPopup(false);
    // Redirect to the first question
    window.location.href = '/quiz/1';
  };
  return <div className="container mx-auto px-4 py-8 md:py-12" data-id="element-116">
      <style jsx global data-id="element-117">{`
        @keyframes pulse-animation {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.7);
            transform: scale(1);
          }
          50% {
            box-shadow: 0 0 0 10px rgba(37, 99, 235, 0);
            transform: scale(1.03);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
            transform: scale(1);
          }
        }
        @keyframes color-pulse {
          0% {
            background-color: #2563eb;
          }
          50% {
            background-color: #1d4ed8;
          }
          100% {
            background-color: #2563eb;
          }
        }
        .pulse-button {
          animation:
            pulse-animation 2s infinite,
            color-pulse 3s infinite;
        }
      `}</style>
      <QuizExitPopup isVisible={showExitPopup} onClose={() => setShowExitPopup(false)} onContinue={handleContinueQuiz} data-id="element-118" />
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-lg overflow-hidden" data-id="element-119">
        <div className="bg-blue-600 py-8 px-6 text-center" data-id="element-120">
          <h1 className="text-2xl md:text-3xl font-bold text-white mb-2" data-id="element-121">
            Glömmer du saker oftare än förr?
          </h1>
          <p className="text-blue-100 text-lg" data-id="element-122">
            Ta detta 2-minuters test och upptäck varför ditt minne kanske
            försämras – och vad du kan göra åt det
          </p>
        </div>
        <div className="p-6 md:p-8" data-id="element-123">
          <div className="flex items-center justify-center mb-8" data-id="element-124">
            <div className="bg-blue-50 p-4 rounded-full" data-id="element-125">
              <BrainIcon className="h-12 w-12 text-blue-600" data-id="element-126" />
            </div>
          </div>
          <div className="text-center mb-8" data-id="element-127">
            <h2 className="text-xl md:text-2xl font-semibold text-gray-800 mb-4" data-id="element-128">
              Känner du igen något av detta?
            </h2>
            <ul className="text-left max-w-md mx-auto space-y-3 text-gray-600 mb-6" data-id="element-129">
              <li className="flex items-start" data-id="element-130">
                <span className="text-blue-500 mr-2" data-id="element-131">✓</span>
                <span data-id="element-132">Du glömmer var du lagt nycklar eller telefonen</span>
              </li>
              <li className="flex items-start" data-id="element-133">
                <span className="text-blue-500 mr-2" data-id="element-134">✓</span>
                <span data-id="element-135">Du tappar tråden mitt i en konversation</span>
              </li>
              <li className="flex items-start" data-id="element-136">
                <span className="text-blue-500 mr-2" data-id="element-137">✓</span>
                <span data-id="element-138">
                  Du behöver läsa samma text flera gånger för att förstå
                </span>
              </li>
              <li className="flex items-start" data-id="element-139">
                <span className="text-blue-500 mr-2" data-id="element-140">✓</span>
                <span data-id="element-141">
                  Du känner dig mentalt trött även efter en normal dag
                </span>
              </li>
            </ul>
            <p className="text-gray-600 mb-6" data-id="element-142">
              Forskning visar att 83% av oss över 40 år upplever försämrat
              minne. Vår hjärna börjar förlora viktiga neurala kopplingar redan
              vid 30 års ålder. Men det finns en lösning.
            </p>
          </div>
          <div className="text-center" data-id="element-143">
            <Link to="/quiz/1" className="inline-flex items-center bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full text-lg transition duration-300 transform hover:scale-105 pulse-button" data-id="element-144">
              Testa Ditt Minne Nu
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-145" />
            </Link>
            <p className="mt-4 text-sm text-gray-500 flex items-center justify-center" data-id="element-146">
              <ClockIcon className="h-4 w-4 mr-1" data-id="element-147" />
              Tar bara 2 minuter • Resultat baserat på forskning • 300 000+ har
              gjort testet
            </p>
          </div>
        </div>
      </div>
      <div className="max-w-3xl mx-auto mt-10 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-148">
        <div className="bg-white p-5 rounded-lg shadow-md text-center" data-id="element-149">
          <div className="text-2xl font-bold text-blue-600 mb-2" data-id="element-150">300 000+</div>
          <div className="text-gray-600" data-id="element-151">Har testat sitt minne</div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md text-center" data-id="element-152">
          <div className="text-2xl font-bold text-blue-600 mb-2" data-id="element-153">91%</div>
          <div className="text-gray-600" data-id="element-154">Rapporterar förbättrat minne</div>
        </div>
        <div className="bg-white p-5 rounded-lg shadow-md text-center" data-id="element-155">
          <div className="text-2xl font-bold text-blue-600 mb-2" data-id="element-156">14 dagar</div>
          <div className="text-gray-600" data-id="element-157">Till märkbara resultat</div>
        </div>
      </div>
    </div>;
};
export default QuizLanding;